import React from 'react';
import appRunSlice from '../appRunSlice';
import ErrorTab from './tabs/ErrorTab';
import InputTab from './tabs/InputTab';
import TermsTab from './tabs/TermsTab';
import { IJobWrapper, IOpenAppPayload, JobStatus } from '../types';
import clsx from 'clsx';

interface IProps {
    openAppPayloadAwaitingAcceptTerms: IOpenAppPayload | null;
    jobWrapper: IJobWrapper | null;
    fullHeight: boolean;

    handleAcceptTerms?: () => void;
    handleConfirmQuit?: () => void;
    handleMinimizeApp?: () => void;
    handleQuitApp?: () => void;
    runJob: typeof appRunSlice.actions.runJob;
}

export default class App extends React.Component<IProps, {}> {
    public render(): React.ReactNode {
        const { jobWrapper, openAppPayloadAwaitingAcceptTerms } = this.props;
        const app = jobWrapper ? jobWrapper.app : openAppPayloadAwaitingAcceptTerms?.app;
        if (!app) {
            return <p>Can not render application</p>;
        }

        return (
            <div
                className={clsx('bg-white shadow rounded-lg ring-1 ring-gray-900/5 p-6', {
                    'h-full': this.props.fullHeight,
                })}
            >
                <this.RenderTab />
            </div>
        );
    }

    private RenderTab: React.FC = () => {
        const { handleAcceptTerms, handleConfirmQuit, jobWrapper, runJob } = this.props;

        if (!jobWrapper) {
            if (!handleAcceptTerms || !handleConfirmQuit) {
                return null;
            }
            return (
                <TermsTab
                    onAcceptTerms={handleAcceptTerms}
                    onQuitApp={handleConfirmQuit}
                    defaultViewIsSignIn={true}
                    requireExplicitContentForGuestMode={true}
                    guestModeDescription={null}
                />
            );
        }

        switch (jobWrapper.status) {
            case JobStatus.input:
                return (
                    <InputTab
                        appRemoteHosts={jobWrapper.job.remote_hosts_with_warning}
                        settings={jobWrapper.job.app_version.settings}
                        resourceVersionUuid={jobWrapper.job.app_version.public_id}
                        onSubmit={(settingValues) => {
                            window.scrollTo(0, 0);
                            runJob({
                                jobId: jobWrapper.job.public_id,
                                settingValues,
                            });
                        }}
                        autoSubmitOnceValid={jobWrapper.job.app_version.auto_run_once_validation_passes}
                    />
                );
            case JobStatus.computing:
            case JobStatus.finished:
                return null;
            case JobStatus.error:
                return <ErrorTab jobWrapper={jobWrapper} onQuit={this.props.handleConfirmQuit} />;
            default:
                return null;
        }
    };
}
